import { isAxiosError } from 'axios';

function isTimeoutOrCancelError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const err = error as { name?: string; code?: string; message?: string };
  if (err.name === 'AbortError' || err.name === 'CanceledError' || err.name === 'TimeoutError') {
    return true;
  }
  if (err.code === 'ECONNABORTED' || err.code === 'ERR_CANCELED') return true;
  if (typeof err.message === 'string' && /timeout|aborted|canceled/i.test(err.message)) {
    return true;
  }
  return false;
}

/**
 * Runtime quota GET: do not overlap a timed-out/cancelled request with an automatic retry.
 * Transient connection failures (no HTTP response) may retry once.
 */
export function shouldRetryRuntimeQuotaQuery(failureCount: number, error: Error): boolean {
  if (failureCount >= 1) return false;
  if (isTimeoutOrCancelError(error)) return false;
  if (isAxiosError(error)) {
    if (error.response) return false;
    return !isTimeoutOrCancelError(error);
  }
  return false;
}
